import React from 'react';
import { ButtonView } from '@vivli/shared/views';
import { buttonIconStyle, buttonStyle } from './button.styles';
import { AssetsConstant, DTISearchButton } from '@vivli/shared/infrastructure/constants';

export const SearchButtonView = ({ onClick }) => {
    return (
        <ButtonView
            // disabled={!canExecuteSearch}
            style={buttonStyle}
            onClick={onClick}
            className="search_go"
            dataId={DTISearchButton.SearchGo}
        >
            <img src={AssetsConstant.WHITE_MAGNIFYING_GLASS} style={buttonIconStyle} />
        </ButtonView>
    );
};
